/**
 * Shared helpers, types, and constants for License Management pages.
 *
 * Extracted from LicenseManagementPage.tsx (Sub-PR 6.3).
 */

import type { LicenseType, LicenseStatus, LicenseCriteriaStatus } from '../../types'

export type TabId = 'licenses' | 'criteria' | 'activation' | 'reports'

export interface LicenseFormData {
  organisationId: string
  licenseKey: string
  licenseType: LicenseType
  seatsTotal: number
  features: string
  validFrom: string
  validUntil: string
}

export interface ExtendFormData {
  validUntil: string
}

export const LICENSE_TYPES: { value: LicenseType; label: string }[] = [
  { value: 'trial', label: 'Trial' },
  { value: 'professional', label: 'Professional' },
  { value: 'enterprise', label: 'Enterprise' },
]

export const LICENSE_STATUSES: { value: LicenseStatus; label: string }[] = [
  { value: 'active', label: 'Active' },
  { value: 'suspended', label: 'Suspended' },
  { value: 'expired', label: 'Expired' },
]

export const CRITERIA_STATUSES: { value: LicenseCriteriaStatus; label: string }[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'verified', label: 'Verified' },
  { value: 'invalid', label: 'Invalid' },
  { value: 'expired', label: 'Expired' },
  { value: 'used', label: 'Used' },
]

export function formatDate(dateStr: string | null): string {
  if (!dateStr) return 'Never'
  return new Date(dateStr).toLocaleDateString('en-AU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export function toDateInputValue(dateStr: string | null): string {
  if (!dateStr) return ''
  const parts = new Date(dateStr).toISOString().split('T')
  return parts[0] ?? ''
}
